/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SpeciesLengthPrior
 */
export interface SpeciesLengthPrior {
    /**
     * 
     */
    scientific: string;
    /**
     * 
     */
    common: string;
    /**
     * 
     */
    typicalMmLow: number;
    /**
     * 
     */
    typicalMmHigh: number;
    /**
     * 
     */
    recordMm: number | null;
    /**
     * 
     */
    source: string;
}

/**
 * Check if a given object implements the SpeciesLengthPrior interface.
 */
export function instanceOfSpeciesLengthPrior(value: object): value is SpeciesLengthPrior {
    if (!('scientific' in value) || value['scientific'] === undefined) return false;
    if (!('common' in value) || value['common'] === undefined) return false;
    if ((!('typicalMmLow' in (value as Record<string, any>)) && !('typical_mm_low' in (value as Record<string, any>))) || ((value as Record<string, any>)['typicalMmLow'] === undefined && (value as Record<string, any>)['typical_mm_low'] === undefined)) return false;
    if ((!('typicalMmHigh' in (value as Record<string, any>)) && !('typical_mm_high' in (value as Record<string, any>))) || ((value as Record<string, any>)['typicalMmHigh'] === undefined && (value as Record<string, any>)['typical_mm_high'] === undefined)) return false;
    if ((!('recordMm' in (value as Record<string, any>)) && !('record_mm' in (value as Record<string, any>))) || ((value as Record<string, any>)['recordMm'] === undefined && (value as Record<string, any>)['record_mm'] === undefined)) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    return true;
}

export function SpeciesLengthPriorFromJSON(json: any): SpeciesLengthPrior {
    return SpeciesLengthPriorFromJSONTyped(json, false);
}

export function SpeciesLengthPriorFromJSONTyped(json: any, ignoreDiscriminator: boolean): SpeciesLengthPrior {
    if (json == null) {
        return json;
    }
    return {
        
        'scientific': json['scientific'],
        'common': json['common'],
        'typicalMmLow': json['typical_mm_low'],
        'typicalMmHigh': json['typical_mm_high'],
        'recordMm': json['record_mm'],
        'source': json['source'],
    };
}

export function SpeciesLengthPriorToJSON(json: any): SpeciesLengthPrior {
    return SpeciesLengthPriorToJSONTyped(json, false);
}

export function SpeciesLengthPriorToJSONTyped(value?: SpeciesLengthPrior | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'scientific': value['scientific'],
        'common': value['common'],
        'typical_mm_low': value['typicalMmLow'],
        'typical_mm_high': value['typicalMmHigh'],
        'record_mm': value['recordMm'],
        'source': value['source'],
    };
}

